export const cilYen = ["24 24","<path d='M18.593 4.585l-1.185-0.92-5.388 6.943-5.038-6.925-1.213 0.882 5.408 7.434h-4.030v1.5h4.103v1.632h-4.103v1.5h4.103v3.618h1.5v-3.618h4.103v-1.5h-4.103v-1.632h4.103v-1.5h-4.015l5.754-7.415z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-yen.js
// module id = null
// module chunks = 